import { type FC } from 'react';

import { Icon } from '@vakantiesnl/components/src/atoms/Icon';
import { useRichText } from '@vakantiesnl/services/src/hooks/contentful';

import { useCustomStyles } from './NoBookingsBlock.style';
import { RichText } from '../../molecules/RichText';

const noBookingsText = {
	['fields.key[in]']: ['user.bookings.noBookingsBlock'],
};

export const NoBookingsBlock: FC = () => {
	const { classes } = useCustomStyles();

	const noBookingsElement = useRichText(noBookingsText);
	const noBookingsBlock = noBookingsElement?.['user.bookings.noBookingsBlock'];

	return (
		<div className={classes.noBookingsBlockContainer} data-cy="no-upcoming-bookings">
			<Icon className={classes.icon} size="xLarge" type="airplaneTakeOff" />
			{noBookingsBlock && <RichText document={noBookingsBlock} />}
		</div>
	);
};
